import {fetch} from '../utils/fetch'
import {casaApiUrl} from 'configs/casa-api'
import moment from 'moment-timezone'
import queryString from 'query-string'

function getSalesDetails(filter) {
  let {
    currentMTDViewStartDate, currentYTDViewStartDate, endDate,
    prevYearMTDViewStartDate, prevYearYTDViewStartDate, prevYearEndDate, storeNames
  } = filter.toJSON()
  let currentMTDViewStartDateParam = moment(currentMTDViewStartDate).format('YYYY-MMM-DD')
  let currentYTDViewStartDateParam = moment(currentYTDViewStartDate).format('YYYY-MMM-DD')
  let endDateParam = moment(endDate).format('YYYY-MMM-DD')
  let prevYearMTDViewStartDateParam = moment(prevYearMTDViewStartDate).format('YYYY-MMM-DD')
  let prevYearYTDViewStartDateParam = moment(prevYearYTDViewStartDate).format('YYYY-MMM-DD')
  let prevYearEndDateParam = moment(prevYearEndDate).format('YYYY-MMM-DD')
  let query = queryString.stringify({
    stores: storeNames,
    currentMTDViewStartDate: currentMTDViewStartDateParam,
    currentYTDViewStartDate: currentYTDViewStartDateParam,
    endDate: endDateParam,
    prevYearMTDViewStartDate: prevYearMTDViewStartDateParam,
    prevYearYTDViewStartDate: prevYearYTDViewStartDateParam,
    prevYearEndDate: prevYearEndDateParam
  })
  return fetch(`${casaApiUrl}/users/summary/salesDetails/filter?${query}`, {
    credentials: 'include',
    method: 'GET'
    // headers: {
    //   'Content-Type': 'application/json'
    // }
  }).then(r => r.json())
}

export default {
  getSalesDetails
}



// WEBPACK FOOTER //
// ./src/services/overall-summary-service.js